import api from ".";

export const listarProdutos = (start, size, filters, filtersMode, globalFilter, sorting, tabelaPrecoId) =>
    api.get("/tabelaPreco/listarProdutos", {
        params: {
            start,
            size,
            filters,
            filtersMode,
            globalFilter,
            sorting,
            tabelaPrecoId,
        },
    });

export const produto = async (novoProduto) => {
    try {
        const { data } = await api.post("/tabelaPreco/produto", novoProduto);
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};

export const duplicidade = async (empresaId, tabelaId, produtoId, embalagemId) => {
    try {
        const data = await api.get("/tabelaPreco/duplicidade/", {
            params: { empresaId, tabelaId, produtoId, embalagemId },
        });
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};

export const deletarProduto = (uuid) => api.post("/tabelaPreco/deletarProdutos", { uuid });

//operações
export const listarOperacao = (start, size, filters, filtersMode, globalFilter, sorting, tabelaPrecoId) =>
    api.get("/tabelaPreco/listarOperacao", {
        params: {
            start,
            size,
            filters,
            filtersMode,
            globalFilter,
            sorting,
            tabelaPrecoId,
        },
    });

export const operacao = async (novaOperacao) => {
    try {
        const { data } = await api.post("/tabelaPreco/operacao", novaOperacao);
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};
export const duplicidadeOperacao = async (tabelaPrecoId, operacaoId) => {
    try {
        const data = await api.get("/tabelaPreco/duplicidadeOperacao/", {
            params: { tabelaPrecoId, operacaoId },
        });
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};
export const deletarOperacao = (uuid) => api.post("/tabelaPreco/deletarOperacao", { uuid });

//listar tabela de preco por empresaIds
export const obterTabelaPrecoByEmpresaIds = async (empresaIds) => {
    try {
        const { data } = await api.post("/tabelaPreco/obterPorEmpresaIds", {
            params: { empresaIds },
        });
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};

export const obterPrecoByEmbalagemId = async (obj) => {
    try {
        const { data } = await api.post("/tabelaPreco/obterPrecoByEmbalagemId", obj);
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};
